import { formatDate } from "@angular/common";
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

declare var google: any;

@Component({
  selector: "app-admin-create-driver-route",
  templateUrl: "./admin-create-driver-route.component.html",
  styleUrls: ["./admin-create-driver-route.component.css"],
})
export class AdminCreateDriverRouteComponent implements OnInit, AfterViewInit {
  createDroForm!: FormGroup;
  loading: boolean = false;
  submitting: boolean = false;
  token: any;

  pickupAutoComplete: any;
  dropAutoComplete: any;
  pickupLat: any = "";
  pickupLong: any = "";
  dropLat: any = "";
  dropLong: any = "";
  pickup_long_name: string = "";
  pickup_short_name: string = "";
  pickup_postal_code: string = "";
  drop_long_name: string = "";
  drop_short_name: string = "";
  dropoff_postal_code: string = "";

  @ViewChild("pickUpLocationSearchField") pickUpLocation!: ElementRef;
  @ViewChild("dropLocationSearchField") dropLocation!: ElementRef;

  minDate: Date = new Date();
  maxDate: Date = new Date();
  truckList: any[] = [];
  categoryList: any[] = [];
  truckTypeList: any[] = [];

  constructor(
    private matDialogRef: MatDialogRef<AdminCreateDriverRouteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private service: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.minDate.setDate(this.minDate.getDate() - 0);
    this.maxDate.setDate(this.maxDate.getDate() + 2);
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.initForm();
    this.fetchMasterData();
  }

  fetchMasterData(): void {
    this.loading = true;
    this.service.GetCategory(this.token, '', '', '', true).subscribe(
      (catRes: any) => {
        if (catRes.status === 200 || catRes.body) {
           this.categoryList = catRes.body?.data || catRes.body || [];
        }
        this.service.GetTrucksTypeAll(this.token).subscribe(
          (typeRes: any) => {
             if (typeRes.status === 200 || typeRes.body) {
               this.truckTypeList = typeRes.body?.data || typeRes.body || [];
             }
             this.loadAvailableTrucks();
          },
          (err) => { this.loadAvailableTrucks(); }
        );
      },
      (err) => { this.loadAvailableTrucks(); }
    );
  }

  initForm(): void {
    this.createDroForm = this.formBuilder.group({
      from_complete_address: ["", Validators.required],
      to_complete_address: ["", Validators.required],
      driver_pin_radius: [30, [Validators.required, Validators.min(1)]],
      truck_selection: ["", Validators.required],
      truck_id: ["", Validators.required],
      truck_number: [""],
      driver_ref_id: ["", Validators.required],
      driver_name: [""],
      driver_mobile: [""],
      truck_type: [""],
      truck_category: [""],
      pickup_date: [new Date(), Validators.required],
      price: ["", [Validators.required, Validators.min(1)]],
    });
  }

  loadAvailableTrucks(): void {
    this.loading = true;
    this.service.getAvailableTrucksForRoute(this.token).subscribe(
      (response: any) => {
        this.loading = false;
        let data = response?.body?.data || response?.body || [];
        if (data && data.data && Array.isArray(data.data)) {
          data = data.data;
        }
        if (Array.isArray(data)) {
          this.truckList = data.map((item: any) => {
            const driver = Array.isArray(item.driverInfo)
              ? item.driverInfo[0]
              : item.driverInfo || (Array.isArray(item.driverDetails) ? item.driverDetails[0] : item.driverDetails) || item.driver || {};
            const driverId = driver._id || driver.id || item.driver_id || item.driver_ref_id || "";
            const driverName = driver.username || driver.name || item.driver_name || "N/A";
            const driverMobile = driver.mobile ? String(driver.mobile) : (driver.phone_number ? String(driver.phone_number) : (item.driver_mobile || ""));
            const truckId = item._id || item.truck_id || (item.truck && item.truck._id) || "";
            const truckNumber = item.truck_number || item.truck_no || item.truckNumber || (item.truck && item.truck.truck_number) || "N/A";

            let displayText = truckNumber;
            const cInfo = item.truckCategoryInfo || item.truckcategoryInfo || item.truckCategory || (item.truck && (item.truck.truckCategoryInfo || item.truck.truckcategoryInfo)) || [];
            let categoryName = cInfo && cInfo.length > 0 ? cInfo[0].truck_category_name : (item.truck_category_name || (item.truck && item.truck.truck_category_name) || "");
            
            if (!categoryName && item.truck_category) {
              const catMatch = this.categoryList.find((c: any) => c._id === item.truck_category);
              if (catMatch) categoryName = catMatch.truck_category_name;
            }

            const tInfo = item.truckTypeInfo || item.trucktypeInfo || item.truckType || (item.truck && (item.truck.truckTypeInfo || item.truck.trucktypeInfo)) || [];
            let weight = tInfo && tInfo.length > 0 ? tInfo[0].truck_weight : (item.truck_weight || (item.truck && item.truck.truck_weight) || "");
            let feet = tInfo && tInfo.length > 0 ? tInfo[0].truck_feet : (item.truck_feet || (item.truck && item.truck.truck_feet) || "");

            if (!weight && !feet && item.truck_type) {
              const typeMatch = this.truckTypeList.find((t: any) => t._id === item.truck_type);
              if (typeMatch) {
                  weight = typeMatch.truck_weight;
                  feet = typeMatch.truck_feet;
              }
            }

            let typeStr = "";
            if (weight && feet) {
                typeStr = `${weight}  ${feet}`;
            } else if (weight) {
                typeStr = `${weight}`;
            } else if (feet) {
                typeStr = `${feet}`;
            } else if (tInfo && tInfo.length > 0 && tInfo[0].truck_type_name) {
                typeStr = tInfo[0].truck_type_name;
            } else {
                typeStr = item.truck_type_name || (item.truck && item.truck.truck_type_name) || "";
            }

            return {
              raw: item,
              truck_id: truckId,
              truck_number: truckNumber,
              driver_id: driverId,
              driver_name: driverName,
              driver_mobile: driverMobile,
              truck_category_name: categoryName,
              truck_type_name: typeStr,
              displayText: displayText,
            };
          });
        }
      },
      (error: any) => {
        this.loading = false;
        this.checkAuthError(error);
      }
    );
  }

  onTruckSelected(truckItem: any): void {
    if (!truckItem) return;
    this.createDroForm.patchValue({
      truck_selection: truckItem,
      truck_id: truckItem.truck_id,
      truck_number: truckItem.truck_number,
      driver_ref_id: truckItem.driver_id,
      driver_name: truckItem.driver_name,
      driver_mobile: truckItem.driver_mobile,
      truck_category: truckItem.truck_category_name,
      truck_type: truckItem.truck_type_name,
    });
  }

  ngAfterViewInit(): void {
    if (typeof google !== "undefined" && google.maps && google.maps.places) {
      const options = {
        componentRestrictions: { country: "in" },
      };

      if (this.pickUpLocation && this.pickUpLocation.nativeElement) {
        this.pickupAutoComplete = new google.maps.places.Autocomplete(
          this.pickUpLocation.nativeElement,
          options
        );
        this.pickupAutoComplete.addListener("place_changed", () => {
          const place = this.pickupAutoComplete.getPlace();
          if (place && place.geometry) {
            this.pickupLat = place.geometry.location.lat();
            this.pickupLong = place.geometry.location.lng();
            this.createDroForm.patchValue({
              from_complete_address: place.formatted_address || place.name,
            });
            this.extractAddressComponents(place, "pickup");
          }
        });
      }

      if (this.dropLocation && this.dropLocation.nativeElement) {
        this.dropAutoComplete = new google.maps.places.Autocomplete(
          this.dropLocation.nativeElement,
          options
        );
        this.dropAutoComplete.addListener("place_changed", () => {
          const place = this.dropAutoComplete.getPlace();
          if (place && place.geometry) {
            this.dropLat = place.geometry.location.lat();
            this.dropLong = place.geometry.location.lng();
            this.createDroForm.patchValue({
              to_complete_address: place.formatted_address || place.name,
            });
            this.extractAddressComponents(place, "drop");
          }
        });
      }
    }
  }

  extractAddressComponents(place: any, type: "pickup" | "drop"): void {
    if (!place) return;
    const components = place.address_components || [];
    let longName = "";
    let shortName = "";
    let postalCode = "";

    for (let i = 0; i < components.length; i++) {
      const types = components[i].types;
      if (types.includes("locality")) {
        shortName = components[i].long_name;
      }
      if (types.includes("sublocality") || types.includes("sublocality_level_1")) {
        longName = components[i].long_name;
      }
      if (types.includes("postal_code")) {
        postalCode = components[i].long_name;
      }
    }

    if (!postalCode && place.formatted_address) {
      const pinMatch = place.formatted_address.match(/\b\d{6}\b/);
      if (pinMatch) {
        postalCode = pinMatch[0];
      }
    }

    if (type === "pickup") {
      this.pickup_long_name = longName || shortName || place.name || "";
      this.pickup_short_name = shortName || longName || place.name || "";
      this.pickup_postal_code = postalCode;
    } else {
      this.drop_long_name = longName || shortName || place.name || "";
      this.drop_short_name = shortName || longName || place.name || "";
      this.dropoff_postal_code = postalCode;
    }

    // If pincode is not yet available, reverse geocode with lat/long
    if (!postalCode && place.geometry && place.geometry.location && typeof google !== "undefined" && google.maps && google.maps.Geocoder) {
      const geoCoder = new google.maps.Geocoder();
      geoCoder.geocode(
        { location: { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() } },
        (results: any, status: any) => {
          if (status === google.maps.GeocoderStatus.OK && results && results.length) {
            for (const result of results) {
              if (result.address_components) {
                for (const comp of result.address_components) {
                  if (comp.types.includes("postal_code") && comp.long_name) {
                    if (type === "pickup") {
                      this.pickup_postal_code = comp.long_name;
                    } else {
                      this.dropoff_postal_code = comp.long_name;
                    }
                    return;
                  }
                }
              }
              const match = (result.formatted_address || "").match(/\b\d{6}\b/);
              if (match) {
                if (type === "pickup") {
                  this.pickup_postal_code = match[0];
                } else {
                  this.dropoff_postal_code = match[0];
                }
                return;
              }
            }
          }
        }
      );
    }
  }

  createDRO(): void {
    const pickupAddress = this.createDroForm.get("from_complete_address")?.value;
    const dropAddress = this.createDroForm.get("to_complete_address")?.value;

    if (pickupAddress && dropAddress && pickupAddress.trim() === dropAddress.trim()) {
      this.snackBar.open("From and To locations cannot be the same", "Fail", {
        duration: 4000,
      });
      return;
    }

    if (!this.pickupLat || !this.pickupLong) {
      this.snackBar.open("Please select correct From location", "Fail", {
        duration: 4000,
      });
      return;
    }

    if (!this.dropLat || !this.dropLong) {
      this.snackBar.open("Please select correct To location", "Fail", {
        duration: 4000,
      });
      return;
    }

    if (this.createDroForm.invalid) {
      this.createDroForm.markAllAsTouched();
      this.snackBar.open("Please fill in all mandatory fields", "Fail", {
        duration: 4000,
      });
      return;
    }

    const farePrice = Number(this.createDroForm.value.price);
    if (!farePrice || farePrice <= 0) {
      this.snackBar.open("Please enter a valid route fare", "Fail", {
        duration: 4000,
      });
      return;
    }

    const rawDate = this.createDroForm.value.pickup_date || new Date();
    const formattedDate = formatDate(rawDate, "yyyy-MM-dd", "en");

    const payload = {
      fromLocation: {
        from_area_name: this.pickup_long_name || this.pickup_short_name || pickupAddress || "",
        from_city_name: this.pickup_short_name || this.pickup_long_name || pickupAddress || "",
        from_pincode: parseInt(this.pickup_postal_code, 10) || 0,
        from_lat: (this.pickupLat || "").toString(),
        from_long: (this.pickupLong || "").toString(),
      },
      toLocation: {
        to_area_name: this.drop_long_name || this.drop_short_name || dropAddress || "",
        to_city_name: this.drop_short_name || this.drop_long_name || dropAddress || "",
        to_pincode: parseInt(this.dropoff_postal_code, 10) || 0,
        to_lat: (this.dropLat || "").toString(),
        to_long: (this.dropLong || "").toString(),
      },
      date: formattedDate,
      price: farePrice,
      route_fare: farePrice,
      driver_pin_radius: parseInt(this.createDroForm.value.driver_pin_radius, 10) || 30,
      truck_id: this.createDroForm.value.truck_id,
      driver_ref_id: this.createDroForm.value.driver_ref_id,
      terms_and_condition: true,
      privacy_policy: true,
      source: "admin",
    };

    this.submitting = true;
    this.service.createDriverRoute(this.token, payload).subscribe(
      (response: any) => {
        this.submitting = false;
        if (response.status === 200 || response.status === 201 || response.body) {
          const successMsg = response.body?.message || "Driver Route Order (DRO) created successfully";
          this.snackBar.open(successMsg, "Success", {
            duration: 5000,
          });
          this.matDialogRef.close({ event: "Success" });
        }
      },
      (error: any) => {
        this.submitting = false;
        this.checkAuthError(error);
        const errMsg = error.error?.message || error.message || "Failed to create Driver Route Order";
        this.snackBar.open(errMsg, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  checkAuthError(error: any): void {
    const errorMsg = error.error?.message || "";
    if (["jwt malformed", "jwt expired", "invalid signature"].includes(errorMsg)) {
      this.router.navigateByUrl("admin/login");
      window.localStorage.clear();
    }
  }

  close(): void {
    this.matDialogRef.close();
  }
}
